<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { startNetworkSpeedMonitor } from "./utils/networkSpeed";

const isSlowNetwork = ref(false);
let stopNetworkMonitor = null;

onMounted(() => {
	stopNetworkMonitor = startNetworkSpeedMonitor((isSlow) => {
		isSlowNetwork.value = isSlow;
	});
});

onBeforeUnmount(() => {
	if (stopNetworkMonitor) stopNetworkMonitor();
});
</script>

<template>
	<div class="main_div">
		<sui-message warning v-if="isSlowNetwork" class="slow-network-banner">
			<sui-icon name="exclamation triangle" />
			Tu conexión a internet es lenta y puede afectar el funcionamiento del sistema.
		</sui-message>
		<router-view></router-view>
	</div>
</template>

<style>
.main_div{
	min-height: 100vh;
}

.slow-network-banner{
	margin: 10px 15px 0;
}
</style>
